import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { getJoinedDoctors } from 'api/signupKeys';
import { toast } from "react-toastify";

const JoinedDoctorsModal = ({ open, onClose, selectedKey }) => {
  const [joinedDoctorsList, setJoinedDoctorsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && selectedKey?._id) {
      fetchDoctors();
    }
  }, [open, selectedKey]);

  const fetchDoctors = async () => {
    setLoading(true);
    const res = await getJoinedDoctors(selectedKey._id);
    if (res?.status === 200) {
      setJoinedDoctorsList(res.data.data || []);
    } else {
      toast.error("Failed to fetch doctors list");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, bgcolor: "#F9F9F9" }}>
        Doctors Joined via Key: {selectedKey?.issuedName}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
            <CircularProgress size={40} />
          </Box>
        ) : joinedDoctorsList.length > 0 ? (
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table size="small">
              <TableHead sx={{ bgcolor: "#F5F5F5" }}>
                <TableRow>
                  <TableCell>
                    <b>Doctor Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Phone/Email</b>
                  </TableCell>
                  <TableCell>
                    <b>Joined Date</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {joinedDoctorsList.map((doc) => (
                  <TableRow key={doc._id} hover>
                    <TableCell>{doc.name || "N/A"}</TableCell>
                    <TableCell>
                      {doc.email && doc.phone ? (
                        <Box>
                          <Typography sx={{ fontSize: "12px",}}>
                            {doc.phone}
                          </Typography>
                            <Typography sx={{ fontSize: "13px", color: "#727272" }}>
                            {doc.email}
                          </Typography>
                        </Box>
                      ) : (
                        doc.email || doc.phone || "N/A"
                      )}
                    </TableCell>{" "}
                    <TableCell>
                      {new Date(doc.createdAt).toLocaleDateString("en-GB")}
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          padding: "2px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          width: "fit-content",
                          bgcolor:
                            doc.doctorStatus === "ACTIVE"
                              ? "#EFFEED"
                              : "#FFF4E5",
                          color:
                            doc.doctorStatus === "ACTIVE"
                              ? "#399F08"
                              : "#FF9800",
                        }}
                      >
                        {doc.doctorStatus || "INACTIVE"}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography align="center" sx={{ py: 5, color: "#727272" }}>
            No doctors have joined using this key yet.
          </Typography>
        )}
      </DialogContent>
      <Box sx={{ p: 2, textAlign: "right", bgcolor: "#F9F9F9" }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </Box>
    </Dialog>
  );
};

export default JoinedDoctorsModal;
